
import on_domready from "domready"

import {
  onLoad as user_menu_onload,
} from "./users/menu/onLoad/use-js-not-link"
import buildings_description_text_box_sometimes_collapsed_style_onload from "./buildings/description_text/box/sometimes_collapsed_style/onLoad"
import listings_onload from "./listings/onLoad"
import browser from "./browser/onLoad"
import auth_onload from "./authentication/onLoad"

import {
  onLoad as building_follow_button_on_load,
} from "./buildings/building_follow_button/index"
import {
  onLoad as neighbourhood_follow_button_on_load,
} from "./neighbourhoods/neighbourhood_follow_button/index"
import {
  onLoad as current_area_size_unit_selection_menu_button_style_on_load,
} from "./app/current_area_size_unit/selection_menu/button_style"
import {
  onLoad as current_area_size_unit_selection_menu_navbar_style_on_load,
} from "./app/current_area_size_unit/selection_menu/navbar_style"
import {
  onLoad as languages_selection_menu_button_style_on_load,
} from "./app/languages/selection_menu/button_style"
import {
  onLoad as languages_selection_menu_navbar_style_on_load,
} from "./app/languages/selection_menu/navbar_style"


const onLoad = () => {
  on_domready(() => {
    current_area_size_unit_selection_menu_button_style_on_load()
    current_area_size_unit_selection_menu_navbar_style_on_load()
    languages_selection_menu_button_style_on_load()
    languages_selection_menu_navbar_style_on_load()
    user_menu_onload()
    buildings_description_text_box_sometimes_collapsed_style_onload()
    building_follow_button_on_load()
    neighbourhood_follow_button_on_load()
    listings_onload()
    browser.onLoad()
    auth_onload.onLoad()
  })
}

export default onLoad
